import { Button, Col, Form, Modal, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';

type IModalRejectProps = {
    visible: boolean;
    onCancel: () => void;
    onReject: (reason: string) => void;
    content?: string;
    title: string;
    isLoading?: boolean;
};

const ModalRejectComponent: React.FC<IModalRejectProps> = React.memo(({ title, isLoading, visible, onCancel, onReject }) => {
    const [form] = Form.useForm();

    const handleReject = (values) => {
        form.resetFields();
        onReject(values.reason);
    }

    return (
        <Modal
            width={600}
            title={title}
            open={visible}
            destroyOnClose={true}
            confirmLoading={isLoading}
            onCancel={onCancel}
            footer={null}
        >
            <Form layout='vertical' form={form} size='large' onFinish={handleReject}>
                <Form.Item label="Lý do" name={'reason'} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                    <TextArea rows={2} />
                </Form.Item>
                <Form.Item>
                    <Row className="action mt-3" justify="end">
                        <Col>
                            <Button
                                className="secondary"
                                onClick={onCancel}
                            >
                                Hủy
                            </Button>
                        </Col>
                        <Col>
                            <Button className="primary" htmlType="submit">
                                Lưu
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </Modal>
    );
});

export default ModalRejectComponent;
